// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@conklin/Overrides/Widgets/Brand/BrandList";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

listStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 32px;
    `,
};

listStyles.brandSections = {
    css: css`
        margin-bottom: 20px;
    `,
};

listStyles.brandAlphabetSections = {
    css: css`
        display: flex;
        flex: 1;
        justify-content: space-between;
        align-items: baseline;
        padding-bottom: 8px;
        margin-bottom: 20px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

listStyles.brandLetter = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
        text-transform: uppercase;
    `,
};

listStyles.brandItemsWrapper = {
    gap: 22,
};

listStyles.brandLink = {
    color: "text.link",
    typographyProps: {
        size: 16,
        lineHeight: "17px",
        forwardAs: "span",
        css: css`
            margin: 0;
        `,
    },
};

listStyles.backToTopLink = {
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
        color: "secondary",
        css: css`
            line-height: 13px;
        `,
    },
};
